import {
  CRMS,
  getUser,
  showToast,
  urlParams,
  wrappedGet,
  wrappedPost,
  yesNoConfirm,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { bindIntegrationSettingsModal } from "../../../../../svelte/src/bindings/integration-settings";
import { allProvidersConfigStore } from "../../../../../svelte/src/modals/IntegrationSettingsModal/stores";

const openIntegrationSettings = bindIntegrationSettingsModal();

const $integrationsFilterSearch = $("#integrationsFilterSearch");
const $integrationsFilterType = $("#integrationsFilterType");

const applySearchFilter = () => {
  const value = $integrationsFilterSearch.val().toLowerCase() || "";
  const type = $integrationsFilterType.selectpicker("val");

  $(".integration-item").each((_, el) => {
    const nameMatchFound = $(el)
      .find(".name")
      .text()
      .toLowerCase()
      .normalize("NFD")
      .includes(value.normalize("NFD"));

    $(el).toggle(
      nameMatchFound && (type === "all" || type === $(el).data("type")),
    );
  });
};

const $clearSearchBtn = $integrationsFilterSearch.find("svg.bi-x-circle-fill");

const displayIntegrationsGrid = () => {
  $("#loadingGrid").hide();
  $("#integrationsGrid").show();

  const allItems = $(".integration-item").toArray();

  const connectedItems = allItems.filter((item) =>
    $(item).find(".connect-badge").hasClass("connected"),
  );
  const nonConnectedItems = allItems.filter(
    (item) => !$(item).find(".connect-badge").hasClass("connected"),
  );

  const alphabeticalSort = (a, b) =>
    $(a).find(".name").text().localeCompare($(b).find(".name").text());

  connectedItems.sort(alphabeticalSort);
  nonConnectedItems.sort(alphabeticalSort);

  const sortedItems = [...connectedItems, ...nonConnectedItems];

  sortedItems.forEach((item) => {
    $("#integrationsGrid").append(item);
  });
};

const COMMUNICATIONS = {
  mailchimp: "Mailchimp",
  mailgun: "Mailgun",
  sendgrid: "SendGrid",
};

const NON_OAUTH_CRMS = [
  "airtable",
  "applicantstack",
  "ashby",
  "avionte",
  "bluesky",
  "breezy",
  "cats",
  "chameleoni",
  "clickup",
  "clockwork",
  "colleague",
  "comeet",
  "copper",
  "crelate",
  "eboss",
  "encore",
  "exelare",
  "ezekia",
  "firefish",
  "greenhouse",
  "highlevel",
  "homerun",
  "itris",
  "jazz",
  "jobdiva",
  "jobvite",
  "kortivity",
  "lessannoying",
  "loxo",
  "manatal",
  "pcrecruiter",
  "peopleforce",
  "personio",
  "pinpoint",
  "recruitcrm",
  "recruitee",
  "recruiterflow",
  "recruitly",
  "recruitmentboost",
  "s3",
  "successfactors",
  "streak",
  "taleo",
  "teamtailor",
  "thrive",
  "voyager",
  "workable",
];

const LICENSES = {
  aeroleads: "AeroLeads",
  anyleads: "Anyleads",
  anymail: "Anymail",
  apollo: "Apollo",
  bettercontact: "BetterContact",
  cognism: "Cognism",
  contactout: "ContactOut",
  datagma: "Datagma",
  dropcontact: "Dropcontact",
  efinder: "Efinder",
  enrow: "Enrow",
  finalscout: "FinalScout",
  findemails: "FindEmails",
  findthat: "Find That Email",
  findymail: "Findymail",
  fullenrich: "FullEnrich",
  getemail: "GetEmail.io",
  getprospect: "GetProspect",
  hunter: "Hunter",
  icypeas: "Icypeas",
  improver: "Improver",
  kaspr: "Kaspr",
  kendo: "Kendo",
  leadiq: "LeadIQ",
  leadgibbon: "LeadGibbon",
  lusha: "Lusha",
  nymblr: "Nymblr",
  nymeria: "Nymeria",
  minelead: "Minelead",
  operia: "Operia",
  orbitly: "Orbitly",
  pdl: "PDL",
  pipileads: "Pipileads",
  pipl: "Pipl",
  prospeo: "Prospeo",
  precontact: "Precontact",
  rampedup: "RampedUp",
  rocketreach: "RocketReach",
  signalhire: "SignalHire",
  skrapp: "Skrapp",
  slintel: "Slintel",
  snov: "Snov",
  swordfish: "Swordfish",
  tomba: "Tomba",
  uplead: "UpLead",
  voilanorbert: "VoilaNorbert",
  wiza: "Wiza",
  zoominfo: "ZoomInfo",
};

const JOB_BOARDS = {
  careerstructure: {
    title: "Career Structure",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  caterer: {
    title: "Caterer",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  cityjobs: {
    title: "CityJobs",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  cvlibrary: {
    title: "CV-Library",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
      email: { type: "email", placeholder: "Email" },
    },
  },
  cvlibraryteaser: {
    title: "CV-Library (Teaser)",
    inputs: {
      company: { type: "text", placeholder: "Company" },
      apiKey: { type: "text", placeholder: "API Key" },
    },
  },
  cwjobs: {
    title: "CWJobs",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  efinancialcareers: {
    title: "eFinancialCareers",
    inputs: {
      apiKey: { type: "text", placeholder: "API Key" },
      password: { type: "password", placeholder: "API Password" },
    },
  },
  emedcareers: {
    title: "eMedCareers",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  jobserve: {
    title: "Jobserve",
    inputs: {
      accountNumber: { type: "text", placeholder: "Account Number" },
      authCode: { type: "text", placeholder: "Auth Code" },
    },
  },
  jobsite: {
    title: "Jobsite",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  justengineers: {
    title: "JustEngineers",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  /*
  monster: {
    title: "Monster",
    inputs: {
      clientId: { type: "text", placeholder: "Client ID" },
      clientSecret: { type: "text", placeholder: "Client Secret" },
    },
  },
  */
  retailchoice: {
    title: "RetailChoice",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
  totaljobs: {
    title: "TotalJobs",
    inputs: {
      username: { type: "text", placeholder: "Username" },
      password: { type: "password", placeholder: "Password" },
    },
  },
};

const EXTERNAL_DIALERS = { aircall: "Aircall", ringover: "Ringover" };

const PRODUCTIVITY = {
  googlesheets: {
    title: "Google Sheets",
    download_url:
      "https://workspace.google.com/marketplace/app/sourcewhale/208912060098",
  },
};

const CUSTOM_MAPPINGS = {};
const CHOICES = {};
const LOCKED_CHOICES = {};
const DATA_REFRESH = {};

const addIntegrationItem = (provider, title, typeString, type) => {
  const id = `${provider}IntegrationItem`;

  // removed attributes to stop bootstrap click handling
  // data-toggle="modal" data-target="#${provider}-modal"
  $("#integrationsGrid").append(/* html */ `
      <div id="${id}" class="integration-item" data-type="${type}">
        <div class="d-flex align-items-center justify-content-between">
          <img src="/assets/img/${type}/${provider}.png">
          <div id="${provider}Check" class="connect-badge font-weight-bold"></div>
        </div>
        <div class="name font-weight-bold mt-3">${title}</div>
        <div class="type">${typeString}</div>
      </div>
    `);

  if (type !== "crm")
    $(`#${id}`).on("click", () => {
      $(`#${provider}-modal`).modal("show");
    });
};

const saveSettings = (provider) => {
  const data = {
    provider,
    choices: CHOICES[provider],
    customMap: CUSTOM_MAPPINGS[provider],
    lockedChoices: LOCKED_CHOICES[provider],
    dataRefresh: DATA_REFRESH[provider],
  };

  wrappedPost({
    url: "/api/integrations/save",
    data: JSON.stringify(data),
    success: () => {
      showToast({
        title: "Integration settings saved",
        type: "success",
      });
    },
    spinner: `#${provider}SaveBtn`,
  });
};

const connectActivationBtn = (provider) => {
  $(document).on("click", `#${provider}ActivateBtn`, () => {
    if (
      NON_OAUTH_CRMS.includes(provider) ||
      JOB_BOARDS[provider] ||
      LICENSES[provider] ||
      COMMUNICATIONS[provider] ||
      EXTERNAL_DIALERS[provider]
    ) {
      const data = { provider };

      [
        "accessKeyId",
        "accountNumber",
        "agencyApiKey",
        "agencySlug",
        "apiId",
        "apiKey",
        "apiToken",
        "appId",
        "authCode",
        "bearerToken",
        "bucket",
        "clientId",
        "clientSecret",
        "company",
        "companyId",
        "database",
        "databaseId",
        "domain",
        "email",
        "frontOfficeTenantId",
        "password",
        "privateKey",
        "secret",
        "secretAccessKey",
        "selfHostedUrl",
        "server",
        "serviceKey",
        "source",
        "subdomain",
        "subscriptionKey",
        "tableUrl",
        "tenant",
        "username",
      ].forEach((key) => {
        data[key] = $(`#${provider}${key}Input`).val();
      });

      if ($(`#${provider}PlanSelector`).length) {
        data.plan = $(`#${provider}PlanSelector`).selectpicker("val");
      }

      // mailgun can have domains in either the US or the EU
      // teamtailor can have a NA region which must use a different API URL
      if ($(`#${provider}RegionSelector`).length) {
        data.region = $(`#${provider}RegionSelector`).selectpicker("val");
      }

      wrappedPost({
        url: "/api/integrations/save_api_key",
        data: JSON.stringify(data),
        success: () => {
          window.location.hash = "intSuccess";
          window.location.reload();
        },
        spinner: `#${provider}ActivateBtn`,
      });
      return;
    }

    const params = { kind: provider };

    [
      "subdomain",
      "apiKey",
      "agencySlug",
      "bearerToken",
      "clientId",
      "clientSecret",
      "domain",
      "username",
      "password",
      "tableUrl",
    ].forEach((key) => {
      params[key] = $(`#${provider}${key}Input`).val();
    });

    if (Object.values(params).includes("")) {
      showToast({
        title: "Please enter all of the required information",
        type: "warning",
      });
      return;
    }

    wrappedGet({
      url: "/api/integrations/activation_url",
      data: params,
      success: (res) => {
        window.location = res.url;
      },
      spinner: `#${provider}ActivateBtn`,
    });
  });
};

const connectDeactivationBtn = (provider) => {
  $(`#${provider}DeactivateBtn`).on("click", () => {
    yesNoConfirm(
      "The integration will be deactivated for your entire team. Are you sure you want to continue?",
      () =>
        wrappedPost({
          url: "/api/integrations/deactivate",
          data: JSON.stringify({ provider }),
          success: () => {
            window.location.hash = "";
            window.location.reload();
          },
        }),
    );
  });
};
const confirmDisconnectBtn = (provider, providerName) => {
  $(`#${provider}ConfirmDisconnectBtn`).on("click", () => {
    wrappedPost({
      url: "/api/integrations/deactivate",
      data: JSON.stringify({ provider }),
      success: () => {
        window.location.hash = "";
        window.location.reload();
      },
      error: () => {
        showToast({
          title: `Failed to disconnect ${providerName}`,
          type: "danger",
          subtitle: "Please contact issue support if the issue persists",
        });
      },
    });
  });
};

// Used to display activation modal if admin has activated the integration, but the user hasn't
const CRM_MISSING_INDIVIDUAL_SIGN_IN = Object.keys(CRMS).reduce(
  (acc, provider) => {
    acc[provider] = true;
    return acc;
  },
  {},
);

const processCrms = (res) => {
  Object.entries(res).forEach(([provider, providerVal]) => {
    if (!CRMS[provider]) return;
    if (providerVal.autoDisconnect) return;

    if (!providerVal.missingIndividualSignIn)
      CRM_MISSING_INDIVIDUAL_SIGN_IN[provider] = false;

    $("#integrationsGrid").prepend($(`#${provider}IntegrationItem`));

    $(`#${provider}ActivatedRow`).show();
    $(`#${provider}Check`).addClass("connected");

    $(`#${provider}Container`).show();
  });
};

const processOtherIntegrations = (integrationDict, res) => {
  Object.keys(integrationDict).forEach((provider) => {
    $(`#${provider}ActivatedRow`).hide();
  });

  Object.entries(res).forEach(([provider, providerVal]) => {
    if (!integrationDict[provider]) return;

    $("#integrationsGrid").prepend($(`#${provider}IntegrationItem`));

    $(`#${provider}activateDiv`).hide();
    $(`#${provider}ActivatedRow, #${provider}DeactivateRow`).show();
    $(`#${provider}Check`).addClass("connected");
    $(`#${provider}activatorSpan`).text(providerVal.activatorName);
  });
};

const processDisconnects = (res) => {
  const providers = Object.values(res)
    .filter((item) => item.autoDisconnect)
    .map((item) => item.provider);
  providers.forEach((provider) => {
    $("#integrationsGrid").prepend($(`#${provider}IntegrationItem`));
    $(`#${provider}ActivatedRow`).show();
    $(`#${provider}Check`).addClass("disconnected");
    $(`#${provider}ActivateBtn`).addClass("reactivate");
    $(`#${provider}ActivateBtn  span`).text("Reactivate");
    $(`#${provider}activateDiv`).prepend(
      "<p><strong>The integration has been disconnected. Please re-enter the details below to reactivate this integration.</strong></p>",
    );
    const providerName = $(`#${provider}IntegrationItem .name`).text();

    $(`#${provider}activateDiv .col`).addClass("d-flex justify-content-between")
      .prepend(`<button class="btn btn-light" id="${provider}ConfirmDisconnectBtn" type="button">
      <i class="fas fa-unlink mr-2"></i>I am no longer using ${providerName} </button>`);
    confirmDisconnectBtn(provider, providerName);
  });
};

const bindTooltips = () => {
  $(document).on(
    "shown.bs.select",
    ".selectpicker[data-kind='createNotesUpon']",
    (e) => {
      const providerTitle = $(e.target).data("provider-title");
      const tooltips = {
        initialEmail: `Create a note in ${providerTitle} when the first email of any campaign is sent, regardless of its position in the campaign`,
        followUpEmail: `Create a note in ${providerTitle} for any email that isn't a first email`,
        bounce: `Create a note in ${providerTitle} for bounced emails from a campaign`,
        emailReply: `Create a note in ${providerTitle} when a recipient replies to any of your campaign emails`,
        externalEmail: `Create a note in ${providerTitle} for emails sent outside of a campaign`,
        externalEmailReply: `Create a note in ${providerTitle} when there is a reply to an email sent outside of a campaign`,
      };

      Object.keys(tooltips).forEach((optionType) => {
        const select = $(`.modal.fade.show .${optionType}`);
        if (select.length)
          select.closest("li").tooltip({
            title: tooltips[optionType],
            html: true,
          });
      });
    },
  );
};

export const initializeIntegrations = () => {
  $(document).on("keyup", $integrationsFilterSearch, applySearchFilter);

  $(document).on("change", $integrationsFilterType, applySearchFilter);

  $(document).on("click", $clearSearchBtn, () => applySearchFilter());

  Object.entries(CRMS).forEach(([provider, title]) => {
    addIntegrationItem(provider, title, "CRM/ATS", "crm");

    $(`#${provider}IntegrationItem`).on("click", () => {
      const isActivated =
        $(`#${provider}Check`).hasClass("connected") &&
        (!CRM_MISSING_INDIVIDUAL_SIGN_IN[provider] ||
          getUser().userId?.startsWith("demo::"));
      // Temporarily ignore missing individual sign in for demo users

      if (isActivated) {
        openIntegrationSettings({ provider, title, type: "crm" });
      } else {
        $(`#${provider}-modal`).modal("show");
      }
    });
  });

  if (urlParams.get("provider")) {
    const provider = urlParams.get("provider");
    $(`#${provider}-modal`).modal("show");
  }

  Object.entries(COMMUNICATIONS).forEach(([provider, title]) => {
    addIntegrationItem(
      provider,
      title,
      "Communication Service",
      "communication",
    );
  });

  Object.entries(LICENSES).forEach(([provider, title]) => {
    addIntegrationItem(provider, title, "Data Provider", "licenses");

    $(`#${provider}ActivatedRow`).after(/* html */ `
        <div class="row" id="${provider}DeactivateRow" style="display: none">
          <div class="col">
            <button class="btn btn-light" id="${provider}DeactivateBtn" type="button">
            <i class="fas fa-unlink mr-2"></i>Deactivate</button>
          </div>
        </div>
      `);
  });

  if (["standard", "trial"].includes(getUser().notetakerPlan)) {
    Object.entries(EXTERNAL_DIALERS).forEach(([provider, title]) => {
      addIntegrationItem(provider, title, "Dialer", "external-dialer");

      $(`#${provider}ActivatedRow`).after(/* html */ `
        <div class="row" id="${provider}DeactivateRow" style="display: none">
          <div class="col">
            <button class="btn btn-light" id="${provider}DeactivateBtn" type="button">
            <i class="fas fa-unlink mr-2"></i>Deactivate</button>
          </div>
        </div>
      `);
    });
  }

  Object.entries(JOB_BOARDS).forEach(([provider, opts]) => {
    addIntegrationItem(provider, opts.title, "Job Board", "jobboards");

    $("#integrationsModals").append(/* html */ `
        <div class="modal fade" id="${provider}-modal">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-body">
                <div id="${provider}activateDiv">
                  <div id="${provider}activateInputsDiv"></div>
                  <div class="row mt-4">
                    <div class="col">
                      <button class="btn btn-light" id="${provider}ActivateBtn" type="button">
                        <i class="fas fa-plug mr-2" id="${provider}ActivateBtnIcon"></i>
                        <span id="${provider}ActivateBtnSpan">Activate</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row mt-4" id="${provider}ActivatedRow">
                  <div class="col">
                    <p><span class="mr-1" id="${provider}activatorSpan"></span>activated this job board for your team.</p>
                  </div>
                </div>
                <div class="row" id="${provider}DeactivateRow" style="display: none">
                  <div class="col">
                    <button class="btn btn-light" id="${provider}DeactivateBtn" type="button">
                    <i class="fas fa-unlink mr-2"></i>Deactivate</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);

    Object.entries(opts.inputs).forEach(([key, val]) => {
      $(`#${provider}activateInputsDiv`).append(`
          <form class="my-2">
            <input type="${val.type}" class="form-control" id="${provider}${key}Input" placeholder="${val.placeholder}" />
          </form>`);
    });
  });

  Object.entries(PRODUCTIVITY).forEach(([provider, opts]) => {
    const type = "productivity";
    const typeString = "Productivity";

    $("#integrationsGrid").append(/* html */ `
        <a id="${provider}IntegrationItem" class="integration-item downloadable" data-type="${type}" href="${opts.download_url}" target="_blank">
          <div class="d-flex align-items-center justify-content-between">
            <img src="/assets/img/${type}/${provider}.png">
            <div id="${provider}Check" class="connect-badge font-weight-bold"></div>
          </div>
          <div class="name font-weight-bold mt-3">${opts.title}</div>
          <div class="type">${typeString}</div>
        </a>
      `);
  });

  if (window.location.hash === "#intSuccess") {
    showToast({
      title: "Successfully added new integration",
      type: "success",
    });
  }

  [CRMS, JOB_BOARDS, LICENSES, COMMUNICATIONS, EXTERNAL_DIALERS].forEach(
    (integrationDict) => {
      Object.keys(integrationDict).forEach((provider) => {
        connectActivationBtn(provider);
        connectDeactivationBtn(provider);
        $(`#${provider}SaveBtn`).click(() => saveSettings(provider));
      });
    },
  );

  $(document).on("input", "#inveniassubdomainInput", (e) => {
    const href = `https://${e.target.value}.invenias.com/api`;
    $("#inveniasLink").text(href).attr("href", href);
    $("#inveniasApiKeyDiv").show();
  });

  $(document).on("input", "#ebosssubdomainInput", (e) => {
    const href = `https://${e.target.value}.recruitsonline.com/myoffice/settings/applications`;
    $("#ebossLink").text(href).attr("href", href);
    $("#ebossApiKeyDiv").show();
  });

  $(document).on("click", ".data-toggle", (e) => {
    const icon = $(e.target).find("i");
    icon.toggleClass("fa-arrow-circle-up fa-arrow-circle-down");
  });

  $(document).on("click", ".data-toggle i", (e) => {
    $(e.target).toggleClass("fa-arrow-circle-up fa-arrow-circle-down");
  });

  wrappedGet({
    url: "/api/integrations/get_all",
    data: {
      excludeOverrides: true,
      includeFields: true,
      includeOptions: true,
      includeMissingSignin: true,
      includeNonCrm: true,
      includeAutoDisconnects: true,
    },
    success: (res) => {
      allProvidersConfigStore.set(res);
      processDisconnects(res);
      processCrms(res);
      processOtherIntegrations(JOB_BOARDS, res);
      processOtherIntegrations(LICENSES, res);
      processOtherIntegrations(EXTERNAL_DIALERS, res);
      processOtherIntegrations(COMMUNICATIONS, res);
      bindTooltips();
      displayIntegrationsGrid();
    },
  });

  $(".send-request-btn").click((e) => {
    const provider = $(e.currentTarget).data("provider");

    wrappedPost({
      url: "/api/integrations/send_request",
      data: JSON.stringify({ provider }),
      success: (res) => {
        showToast({
          title: "Integration request sent",
          subtitle: res.response,
          type: "success",
          timeout: 30000,
        });
      },
      spinner: ".send-request-btn",
    });
  });
};
